import { Flex, Box, Spacer, Text, Link, Heading } from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link as ReachLink } from "react-router-dom";
import { RootStore } from "../../../redux/Store";
import UISkeletons from "../Utils/UiSkeletons";
import GovernmentCard from "./GovernmentCard";
import PoliticalPartyCard from "./PoliticalPartyCard";
import PoliticianCard from "./PoliticianCard";

function MainHeading({ TopHeading, Route, Path, SubHeading }: HeadingProps) {
  return (
    <>
      <Flex as="body" align="center" justify="space-between" wrap="wrap">
        <Box p="1">
          <Heading as="h3">{TopHeading}</Heading>
          <Spacer />
          <Text fontStyle="italic">- {SubHeading}</Text>
        </Box>
        <Spacer />
        <Box
          // mt={{ base: 4, md: 0 }}
          alignItems="center"
        >
          <Link
            background="white"
            color="#D10024"
            display={{ base: "none", md: "flex" }}
            outline="#D10024"
            border="1px"
            height="fit-content"
            borderRadius="2.5px"
            padding={3}
            paddingInline={3}
            fontSize="md"
            className="btn"
            _hover={{ bg: "#D10024", color: "white", outline: "#D10024" }}
            colorScheme="blue"
            as={ReachLink}
            to={String(Path)}
            _focus={{
              boxShadow: "none",
              textDecor: "none",
            }}
          >
            {Route}
          </Link>
        </Box>
      </Flex>
    </>
  );
}

function MobileViewLink({ Route, Path }: MobileViewLinkProps) {
  return (
    <>
      <Link
        background="white"
        display={{ base: "block", md: "none" }}
        color="#D10024"
        outline="#D10024"
        border="1px"
        width="fit-content"
        height="fit-content"
        margin="auto"
        marginBottom="2"
        borderRadius="2px"
        padding={2}
        paddingInline={2}
        fontSize="md"
        className="btn"
        _hover={{ bg: "#D10024", color: "white", outline: "#D10024" }}
        colorScheme="blue"
        as={ReachLink}
        to={Path}
        _focus={{
          boxShadow: "none",
          textDecor: "none",
        }}
      >
        {Route}
      </Link>
    </>
  );
}

function Home() {
  const dataState = useSelector((state: RootStore) => state.data);
  const government = dataState.governmentsData?.governments;
  const politicalParty = dataState.politicalPartiesData?.politicalParties;
  const politicians = dataState.politiciansData?.politicians;
  // const [avgGovRatingCount, setAvgGovRatingCount] = useState(0);
  // const [avgPartyRatingCount, setAvgPartyRatingCount] = useState(0);
  // const [avgPoliticianRatingCount, setAvgPoliticianRatingCount] = useState(0);

  //-------------------------------For ui state-------------------------------
  const uiState = useSelector((state: RootStore) => state.ui);
  const skeleton = Array.from({ length: 4 }).map((item, index) => (
    <UISkeletons key={index} />
  ));
  const govAvgRating = (gov: IgovernmentData): number => {
    let avgRating: number = 0;

    const govReview = gov.reviews;
    for (let i = 0; i < Number(govReview?.length); i++) {
      if (govReview != undefined) {
        avgRating += Number(govReview[i].rating);
      }
    }
    if (Number(govReview?.length)) {
      return avgRating / Number(govReview?.length);
    }
    return 0;
  };
  const partyAvgRating = (party: IpoliticalPartyData): number => {
    let avgRating: number = 0;

    const partyReview = party.reviews;
    for (let i = 0; i < Number(partyReview?.length); i++) {
      if (partyReview != undefined) {
        avgRating += Number(partyReview[i].rating);
      }
    }
    if (Number(partyReview?.length)) {
      return avgRating / Number(partyReview?.length);
    }
    return 0;
  };
  const politicianAvgRating = (politician: IpoliticiansData): number => {
    let avgRating: number = 0;

    const politicianReview = politician.reviews;
    for (let i = 0; i < Number(politicianReview?.length); i++) {
      if (politicianReview != undefined) {
        avgRating += Number(politicianReview[i].rating);
      }
    }
    if (Number(politicianReview?.length)) {
      return avgRating / Number(politicianReview?.length);
    }
    return 0;
  };
  return (
    <>
      <MainHeading
        TopHeading="Be Updated With News"
        Route="View More"
        Path="/government-listing"
        SubHeading="Go through the news, articles and updates related to different
            government"
      />

      <div
        className="row"
        id="governmentRow"
        style={{
          margin: "auto",
          justifyContent: "space-evenly",
        }}
      >
        {!uiState.governmentLoading ? (
          <>
            {government?.slice(0, 4).map((gov) => (
              <>
                <GovernmentCard
                  _id={String(gov._id)}
                  image={String(gov.image)}
                  status={String(gov.status)}
                  country={String(gov?.majority?.country?.name)}
                  description={String(gov.description)}
                  manOnIncharge={String(gov.manOnIncharge)}
                  reviewCount={gov.reviews?.length}
                  rating={govAvgRating(gov)}
                />
              </>
            ))}
          </>
        ) : (
          skeleton
        )}
      </div>

      <MobileViewLink Route="View More" Path="/government-listing" />

      <MainHeading
        TopHeading="Political Parties Around The Globe"
        Route="Show All"
        Path="/political-parties-listing"
        SubHeading="Learn and analyze about political parties of the countries around the globe"
      />

      <div
        className="row"
        id="politicalPartyRow"
        style={{
          margin: "auto",
          justifyContent: "space-evenly",
        }}
      >
        {!uiState.politicalPartyLoading ? (
          <>
            {politicalParty?.slice(0, 4).map((party) => (
              <PoliticalPartyCard
                _id={String(party._id)}
                image={String(party.image)}
                name={String(party.name)}
                description={String(party.description)}
                isGoverning={String(party.isGoverning)}
                country={String(party?.country?.name)}
                reviewCount={party.reviews?.length}
                rating={partyAvgRating(party)}
              />
            ))}
          </>
        ) : (
          skeleton
        )}
      </div>
      <MobileViewLink Route="Show All" Path="/political-parties-listing" />

      <MainHeading
        TopHeading="Trending Politicians"
        Route="Show All"
        Path="/politicians-listing"
        SubHeading="Know about various politicians and their involvement in politics"
      />
      <div
        className="row"
        id="politicianRow"
        style={{
          margin: "auto",
          justifyContent: "space-evenly",
        }}
      >
        {!uiState.politicianLoading ? (
          <>
            {politicians?.slice(0, 4).map((politician) => (
              <PoliticianCard
                _id={politician._id}
                name={politician.name}
                details={politician.details}
                country={politician?.politicalParty?.country?.name}
                image={politician.image}
                reviewCount={politician.reviews?.length}
                politicalParty={politician?.politicalParty?.name}
                rating={politicianAvgRating(politician)}
              />
            ))}
          </>
        ) : (
          skeleton
        )}
      </div>
      <MobileViewLink Route="Show All" Path="/politicians-listing" />
    </>
  );
}

export default Home;
